<template>
  <on-click-outside @do="closeAndSelect" class="w-full h-full" >
    <div class="w-full h-12 relative">
      <div class="flex w-full h-12 items-center" v-show="!isOpen">
        <slot />
        <button
          ref="button"
          @click="open"
          type="button"
          aria-label="press enter to to open smart search to find City, Address, Subdivision, or MLS#"
          class="flex-grow text-left h-12 overflow-hidden"
        >
          <div v-if="omni !== null && omni !== ''" class="text-input flex items-center">
            {{ toTitleCase(omni) }}
          </div>
          <div v-else class="text-input flex items-center h-12 py-3">{{ preview }}</div>
        </button>
        <span
          v-if="omni !== ''"
          @click="clear"
          @keydown.enter="clear"
          class="h-8 w-8 bg-gray-100 dark:bg-gray-900 dark:text-white flex items-center justify-center mr-2 cursor-pointer focus:bg-gray-500 hover:bg-gray-500"
          role="link"
          aria-label="press enter to clear current smart search selection"
          tabindex="0"
        >
          <svg-vue icon="times" class="dark:text-white fill-current h-5 w-5" ></svg-vue>
        </span>
      </div>
      <div class="block w-full relative" ref="dropdown" v-show="isOpen">
        <input
          class="text-input"
          name="omni"
          v-model="omni"
          @keydown.esc="close"
          autocomplete="off"
          @keyup.enter.prevent="closeAndSelect"
          aria-label="Type to query available searches. Press tab to navigate options, or escape to cancel."
        />
      </div>
      <div
        class="absolute z-50 -top-3 -left-3 -right-3 h-auto p-3 shadow-lg shadow-primary-dark bg-white dark:bg-primary-dark/90 backdrop-blur-lg flex flex-col border-b-2 border-accent"
        v-show="isOpen"
      >
        <div class="mb-3 h-12 input-wrapper">
          <slot />
          <input
            ref="search"
            placeholder="Type for available searches"
            aria-label="Type for available searches, press tab to select one"
            class="text-input"
            v-model="omni"
            @keydown.esc="close"
            autocomplete="off"
            id="omni-field"
            @keydown.enter.prevent="closeAndSelect"
          />
        </div>
        <div ref="options" v-if="options.length > 0" class="overflow-hidden shadow-lg bg-primary h-64 b-3">
          <div class="h-full overflow-y-scroll mb-3 text-left">
            <div
              v-for="category in options"
              :key="category.text"
            >
              <div v-if="category.children.length > 0" >
                <div class="py-2 px-3 my-1 bg-primary-dark/50 text-accent uppercase font-bold text-sm w-full" >
                  {{ category.text }}
                </div>
                <div
                  v-for="child in category.children"
                  :key="child"
                  @click="select(child)"
                  @keyup.enter="select(child)"
                  :aria-label="'press enter to select ' + child"
                  role="link"
                  tabindex="0"
                  class="py-1 px-3 hover:bg-tan-light text-white text xl:text-sm hover:font-bold cursor-pointer"
                >
                  {{ toTitleCase(child) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="omni.length > 2" class="text-gray-400 italic p-4" tabindex="0">
          No results found for <strong>{{ omni }}</strong>
        </div>
        <div class="flex justify-between" >
          <a
            @click="closeAndSelect"
            @keyup.enter="closeAndSelect"
            role="link"
            aria-label="press enter to close the menu and select current search phrase"
            class="mt-auto pt-3 px-1 underline cursor-pointer text-white"
          >close</a>
          <a
            @click="clear"
            @keyup.enter="clear"
            role="link"
            aria-label="press enter to cancel current selection and close the smart search tool"
            class="mt-auto pt-3 px-1 underline cursor-pointer text-error"
          >cancel</a>
        </div>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import OnClickOutside from "./OnClickOutside.vue";

export default {

  components: {
    "on-click-outside": OnClickOutside,
  },

  props: ["value", "fieldValue", "preview"],

  data() {
    return {
      isOpen: false,
      omni: "",
      baseUrl: "https://rets.kerigan.com/api/v2/smartfield",
      association: 'rafgc',
      omniTerms: [],
    };
  },

  mounted() {
    if (this.fieldValue !== "") {
      this.select(this.fieldValue);
    }
  },

  computed: {
    options () {
      if(this.omniTerms.length > 0){
        return this.filter(this.omni)
      } else {
        return []
      }
    }
  },

  methods: {
    getOptions (value){
      let vm = this

      fetch(vm.baseUrl + '?association=' + this.association)
        .then(res => res.json())
        .then(options => {
          vm.omniTerms = options
        })
    },

    open() {
      this.isOpen = true;
      this.getOptions();

      this.$nextTick(() => {
        this.focusInput()
      })
    },

    focusInput() {
      this.$refs.search.focus()
    },

    close() {
      if (!this.isOpen) return
      this.isOpen = false
    },

    closeAndSelect() {
      this.$emit("updated", {
          property: 'omni',
          value: this.omni
      })
      this.close()
    },

    clear() {
      this.omni = ""
      this.$emit("updated", {
          property: 'omni',
          value: ""
      })
      this.close()
    },

    select(option) {
      console.log(option)
      this.omni = option
      this.$emit("updated", {
          property: 'omni',
          value: option
      })
      this.close()
    },

    toTitleCase(str) {
      if (!str) {
        return "";
      }
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },

    filter (text) {
      let options = []
      this.omniTerms.forEach(category => {
        options.push({
          text: category.text,
          children: category.children.filter(term => {
            return term != null && text != null && term.toLowerCase().includes(text.toLowerCase())
          })
        })
      })
      return options
    }
  },
};
</script>
